import React from "react";

import { UserDropDownMenu } from "components/molecules";
import { useSelector } from "react-redux";
import DefaultImg from "assets/images/PNG/blank.png";
import { SmartImage } from "components/atoms";

export function HeaderTopbar() {
  const { me } = useSelector((state) => state.me);
  return (
    <div className="flex items-center gap-3">
      <div className="flex items-center gap-3">
        <p className="font-medium text-mono text-[14px]">{me?.name}</p>
      </div>
      <UserDropDownMenu
        trigger={
          <div className="size-10 overflow-hidden rounded-full">
            <SmartImage
              src={me?.profile_url}
              alt="profile"
              size={40}
              className="w-full h-full object-cover"
              fallback={
                <div className="size-10 rounded-full flex justify-center items-center">
                  <img
                    src={DefaultImg}
                    alt="profile"
                    className="w-full h-full img-cover"
                  />
                </div>
              }
            />
          </div>
        }
      />
    </div>
  );
}
